import ChalkySticks from '@chalkysticks/sdk';

/**
 * iOS is going to get the model without the arena
 * for now until we can better understand the performance
 * and why it crashes.
 *
 * We might even more into a skybox situation if we
 * can get funding.
 *
 * @type string
 */
// export const TRAINER_MODEL_URL = '/model/model-b-1024-webp-draco.glb';
// export const TRAINER_MODEL_URL = '/model/model-b-512-webp-draco.glb';
export const TRAINER_MODEL_URL = '/model/model-b-1024-uastc-draco.glb';

/**
 * Default environment for the Trainer plugin
 * e.g. Chalky, OldPoolHall, AmsterdamBilliards, Generic
 *
 * @type string
 */
export const TRAINER_ENVIRONMENT = 'Chalky';

/**
 * Default environment for the Trainer plugin
 * e.g. Chalky, Charcoal, Classic, Matchroom, Traditional
 *
 * @type string
 */
export const TRAINER_TABLE_APPEARANCE = 'Chalky';
